import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { isUndef } from '@/lib/utils';
import EquipmentGift from '@/models/equipmentGift';

class UserInfo {
    public name: string;
    public gender: string;
    public age: string;
    public mobile: string;
    public district: number[];
    public address: string;
    public can_change_address: boolean;
    /** 在该时间点之前可以修改 */
    public can_change_before: string;
    public gifts: EquipmentGift[];
    public change_spec_days: number;
    public lettering: string;
    public change_count: number;

    public constructor(info: Equipment.UserInfo) {
        this.name = info.name;
        this.gender = info.gender;
        this.age = info.age;
        this.mobile = info.mobile;
        this.district = info.district;
        this.address = info.address;
        this.can_change_address = info.can_change_address;
        this.can_change_before = info.can_change_before;
        this.gifts = info.gifts.map((gift) => new EquipmentGift(gift));
        this.change_spec_days = info.change_spec_days;
        this.lettering = info.lettering;
        this.change_count = info.change_count;
    }

    /**
     * 是否存在可以修改的情况
     * todo: 感觉这个没有什么用
     */
    public canModify() {
        let canModify = isUndef(this.can_change_address) ? false : this.can_change_address;
        if (this && this.gifts) {
            this.gifts.forEach((gift: EquipmentGift) => {
                if (gift.can_change === true) {
                    canModify = true;
                }
            });
        }
        return canModify;
    }
}

export interface EquipmentState {
    /** activityId => userInfo */
    userInfo: {
        [activityId: string]: UserInfo | undefined,
    };
    /** 存储从userInfo中获取的gift数据 */
    giftMap: {
        [giftId: number]: Equipment.GiftItem,
    };

    tempEquipmentAddress: number | null;
    SpecialId: string;
    isBinder: object;
}
const m: Module<EquipmentState, RootState> = {
    namespaced: true,
    state: () => ({
        userInfo: {},
        giftMap: {},
        tempEquipmentAddress: null,
        isBinder: {},
        SpecialId: '',
    }),
    mutations: {
        /**
         * 记录用户信息
         */
        setUserInfo(state, { activityId, userInfo }) {
            Vue.set(state.userInfo, activityId, userInfo);
            (userInfo as UserInfo).gifts.forEach((gift) => {
                Vue.set(state.giftMap, gift.id, gift);
            });
        },
        // 是否是帮报名
        isBinder(state, data) {
          state.isBinder = data;
        },
        setTempEquipmentAddress(state, id) {
            console.log('target eqAddress 1-1', id);
            state.tempEquipmentAddress = id;
        },
        SpecialId(state, data) {   // 专题id
          state.SpecialId = data;
        },
    },
    actions: {
        /**
         * 获取用户信息
         *
         * @param {} forceUpdate 是否强制更新
         *
         * @return {} userInfo返回userInfo信息
         */
        async getUserInfo({ state, dispatch, commit }, { activityId, orderId, forceUpdate = false }) {
            const userInfo = state.userInfo[activityId];
            if (userInfo && !forceUpdate) {
                return;
            }
            if (forceUpdate) {
                state.userInfo[activityId] = undefined;
            }

            const response = await Vue.axios.get('/api/v1/gift/user_info', {
                params: {
                    activity_id: activityId,
                    order_id: orderId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const info = rdata.data;
                if (isUndef(info)) {
                    return;
                }
                info.district = [ info.district_1_id, info.district_2_id, info.district_3_id ].filter((_) => _);
                delete info.district_1_id;
                delete info.district_2_id;
                delete info.district_3_id;
                commit('setUserInfo', {
                    activityId,
                    userInfo: new UserInfo(rdata.data),
                });
                commit('isBinder', rdata.data);
            }
        },
        /**
         * 更新userInfo
         *
         * @param {} userInfo 所有的userInfo，允许传入null以覆盖值
         *  - name
         *  - gender
         *  - age
         *  - mobile
         *  - districtLevel1
         *  - districtLevel2
         *  - districtLevel3
         *  - addressDetail
         *  - clothesSize
         *  - app
         *  - knowFrom
         *  - shoeSize
         *
         * @return {} rdata，完整的JSON响应内容
         */
        async updateUserInfo({ state, commit }, { activityId, name, mobile, district, address, orderId, specifications, optional_specifications, invite_specifications, lettering, blind_box_specifications}) {
            const response = await Vue.axios.post('/api/v1/gift/user_info', {
                activity_id: activityId,
                name,
                age: '0',
                // gender: userInfo.gender,
                mobile,
                district_1_id: district?.[0],
                district_2_id: district?.[1],
                district_3_id: district?.[2],
                address,
                specifications,
                optional_specifications,
                invite_specifications,
                order_id: orderId,
                lettering,
                blind_box_specifications,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
